import {USER_PROFILE, TRANSACTIONS} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import types from '../types/appointments'
import simpleSnackbarActions from '../../../common/actions/simpleSnackbar'
import {push} from 'react-router-redux'
import {endpoint as endpointText} from '../../../common/text'
import {ApiError} from '../schemas'
import {appointments as text} from '../text'
import moment from '../../../common/moment'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class appointments {

  static fetch() {
    return function(dispatch, getState) {

      dispatch({type: types.FETCH})

      return apiPrivate.get(USER_PROFILE + '/user/transactions')
        .then(response => {

          const parsed = response.data.description
          if (parsed.transactions === null) parsed.transactions = []

          // Set useful function to each transaction
          let _appointments = parsed.transactions.map(t => {
            t.getMoment = function() {
              return moment.utc(this.ReserveDate).utcOffset(moment().utcOffset(), true)
            }
            return t
          })

          function sortAppointments(dir, a, b) {
            const DayA = a.getMoment()
            const DayB = b.getMoment()
            if (DayA.isBefore(DayB))
              return -1 * dir
            if (DayA.isAfter(DayB))
              return 1 * dir
            return 0
          }

          //TransactionStatusID = 6 means Cancelled
          const futureAppointments = _appointments
            .filter(a => a.Reserve.ID !== 0 && a.getMoment().isSameOrAfter() && a.TransactionStatusID !== 6)
            .sort((a, b) => sortAppointments(1, a, b))
          const previousAppointments = _appointments
            .filter(a => a.Reserve.ID === 0 || a.getMoment().isBefore() || a.TransactionStatusID === 6)
            .sort((a, b) => sortAppointments(-1, a, b))

          const sorted = [...futureAppointments, ...previousAppointments]

          dispatch(appointments.fetchSuccess(sorted))

        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(appointments.fetchFail(message))
              return
            }
            const response = new ApiError(error.response.data)
            message = response.description
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(appointments.fetchFail(message))
        })
    }
  }

  static fetchTransaction(transactionID) {
    return function(dispatch, getState) {

      return apiPrivate.get(USER_PROFILE + '/user/transactions/' + transactionID)
        .then(response => {
          const data = response.data.description
          dispatch(appointments.fetchTransactionSuccess(data))
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(appointments.fetchTransactionFail(message))
              return
            }
            const response = new ApiError(error.response.data)
            message = response.description
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(appointments.fetchTransactionFail(message))
        })
    }
  }

  static fetchSuccess(transactions) {
    return {
      type: types.FETCH_SUCCESS,
      payload: {
        transactions,
      },
    }
  }

  static fetchFail(error) {
    return {
      type: types.FETCH_FAIL,
      payload: {
        error,
      },
    }
  }

  static fetchTransactionSuccess(transaction) {
    return {
      type: types.FETCH_TRANSACTION_SUCCESS,
      payload: {
        transaction,
      },
    }
  }

  static fetchTransactionFail(error) {
    return {
      type: types.FETCH_TRANSACTION_FAIL,
      payload: {
        error,
      },
    }
  }

  static selectTransaction(transaction) {
    return {
      type: types.SELECT_TRANSACTION,
      payload: {
        transaction,
      },
    }
  }

  static cancelAppointment() {
    return function(dispatch, getState) {

      const state = getState().ui.activity.appointments
      const transaction = state.get('transaction')

      if (transaction === null) {
        dispatch(appointments.cancelAppointmentFail(''))
        return
      }

      dispatch({type: types.CANCEL_APPOINTMENT})

      apiPrivate.delete(TRANSACTIONS + '/transactions/' + transaction.ID)
        .then(response => {
          dispatch(appointments.cancelAppointmentSuccess())
          dispatch(simpleSnackbarActions.showMessage(text.actions.eventSuccessfullyCanceled))
          dispatch(appointments.fetch())
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(appointments.cancelAppointmentFail(''))
              return
            }
            const response = new ApiError(error.response.data)
            message = response.description
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(appointments.cancelAppointmentFail(''))
          dispatch(simpleSnackbarActions.showMessage(message))
        })
    }
  }

  static cancelAppointmentSuccess() {
    return {
      type: types.CANCEL_APPOINTMENT_SUCCESS,
    }
  }

  static cancelAppointmentFail(error) {
    return {
      type: types.CANCEL_APPOINTMENT_FAIL,
      payload: {
        error,
      },
    }
  }

  static setCancelDialogOpen(open) {
    return {
      type: types.SET_CANCEL_DIALOG_OPEN,
      payload: {
        open,
      },
    }
  }

  static setViewDialogOpen(open) {
    return {
      type: types.SET_VIEW_DIALOG_OPEN,
      payload: {
        open,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/activity/actions/appointments.js